import {Check} from "@sparkware/app-utils";
import { IAbTestingFeatureProperties } from "../common/interfaces/ab-testing-interface";

export const abTestingFeatureIsValid = (featureObject: IAbTestingFeatureProperties, featureProperties: string[]): any => {

  if (Check.isNullOrUndefined(featureObject) || Check.isNullOrUndefined(featureObject.Properties)) {
    return false;
  }

  for (let i = 0; i < featureProperties.length; i++) {
    if (Check.isNullOrUndefined(featureObject.Properties[featureProperties[i]])) {
      return false;
    }
  }

  return true;
};
